import {
  COLOR_1,
  COLOR_1_BORDER_BOTTOM,
  COLOR_1_BORDER_LEFT,
  COLOR_2,
  COLOR_2_BORDER_BOTTOM,
  COLOR_2_BORDER_RIGHT,
  COLOR_3,
  COLOR_3_BORDER_RIGHT,
} from './config';


/* When changing style !!!
 *  - move this globals to StyledComponents
 *  - here should be only shared variables like errorColor etc.
 */


export const backgroundSideBar = COLOR_3;
export const col_error = '#b91111';

export const MAIN_CONTENT_DATA_WRAPPER_SETTINGS = {
  spinnerFat: 5, 
  spinnerSize: 25, 
  textSizeLoading: 1,
  textSizeError: 1.25,
};



// ~ CSS ~ //

// total page padding = PADDING_PAGE + PADDING_CONTENT_PAGE
//  - PADDING_CONTENT_PAGE - between buttons + in line with other text
export const PADDING_CONTENT_PAGE = 6; 
export const PADDING_PAGE = 6;
export const BORDER_COLOR_LINE_VERTICAL = '#7d7d7d';


// - CSS - HEADER
export const HEIGHT_HEADER = 50;
export const BACKGROUND_HEADER = COLOR_1;
export const BORDER_HEADER = COLOR_1_BORDER_BOTTOM;
export const BORDER_HEADER_LEFT = COLOR_1_BORDER_LEFT;
export const WIDTH_HEADER_IMG = 20;

  // - CSS - HEADER - LOGO
  export const BACKGROUND_HEADER_LOGO = COLOR_2;
  export const BORDER_HEADER_LOGO = COLOR_2_BORDER_BOTTOM;
  export const BORDER_HEADER_LOGO_RIGHT = COLOR_2_BORDER_RIGHT;
  export const FONT_SIZE_HEADER_LOGO = 1.2;
  export const HEIGHT_HEADER_LOGO_ICON_PERCENT = 26;
  // - CSS HEADER - LOGO - MOBILE
  export const BACKGROUND_HEADER_MOBILE = COLOR_1;
  
// - CSS - SIDEBAR
export const WIDTH_SIDE_BAR = 240;
export const BACKGROUND_SIDE_BAR = COLOR_3; // same as map - river
export const BORDER_SIDE_BAR = COLOR_3_BORDER_RIGHT;

  // - CSS - SIDEBAR - BTN
  export const PADDING_BTN_SIDE_BAR = 12; 
  export const FONT_BTN_SIDE_BAR_ICON = 1.4;
  export const FONT_BTN_SIDE_BAR_STEP = 0.75;
  export const FONT_BTN_SIDE_BAR_TITLE = 0.9;
  export const COLOR_BTN_SIDE_BAR = 'white';
  export const FONT_BTN_SIDE_BAR_ICON_MOBILE = 1.5;

  // - CSS - SIDEBAR - SEPARATOR
  export const PADDING_SEPARATOR_SIDE_BAR = 0;
  export const FONT_SEPARATOR_SIDE_BAR_ICON = 20;
  export const COLOR_SIDE_BAR_ICON = 'white';
  export const WIDTH_SIDE_BAR_SEPARATOR_MOBILE = 25;
  export const FONT_SEPARATOR_SIDE_BAR_ICON_MOBILE = 1.5;

// CSS - ERROR
export const BACKGROUND_ERROR = 'rgba(235, 111, 131, 0.36)';
export const COLOR_ERROR = '#b91111';
export const FONT_SIZE_ERROR = 14;

// CSS - LOADER
export const BACKGROUND_LOADER = '#ebe7e7';
export const COLOR_LOADER = '#616161';
export const FONT_SIZE_LOADER = 1;
export const SIZE_LOADER = 15;
export const FAT_LOADER = 3;

// - CSS - BTN_BACK
export const BACKGROUND_BTN_BACK = COLOR_1;
export const BACKGROUND_BTN_BACK_HOVER = COLOR_3;
export const FONT_SIZE_BTN_BACK = 14;
export const FONT_SIZE_BTN_BACK_ARROW = 18;

// - CSS - LABEL
export const FONT_SIZE_LABEL = 0.9;
export const COLOR_MAIN_LABEL = COLOR_1;

// CSS - ROW_HORIZONTAL
export const BACKGROUND_ROW_HORIZONTAL = COLOR_3;
export const BORDER_SIZE_ROW_HORIZONTAL = 2;

// CSS - TITLE_MEDIUM
export const FONT_SIZE_TITLE_MEDIUM = 1;

// CSS - TITLE_TOP
export const FONT_SIZE_TITLE_TOP = 1.325;
export const COLOR_NUMBER_TITLE_TOP = COLOR_1;

// CSS - BTN_OFFICE 
// CSS - BTN_SERVICE
export const FONT_SIZE_BTN_TITLE = 1;
export const FONT_SIZE_BTN_TEXT = 0.9;
export const BACKGROUND_BTN = '#f2f2f2';
export const BACKGROUND_BTN_HOVER = COLOR_1;
export const COLOR_BTN_HOVER = 'white';
export const HEIGHT_BTN = 1; // LINE_HEIGHT_BTN * ROWS
export const LINE_HEIGHT_BTN = 1;
export const FONT_SIZE_BTN_ARROW = 1; 

// CSS - BTN_CONFIRM
export const FONT_SIZE_BTN_CONFIRM_TITLE = 1;
export const BACKGROUND_BTN_CONFIRM = COLOR_1;
export const BACKGROUND_BTN_CONFIRM_HOVER = COLOR_3;
export const BACKGROUND_BTN_CONFIRM_DISABLED = '#ffb06e';
export const COLOR_BTN_CONFIRM_HOVER = 'white';

// CSS - TIBLE_TIMES
export const BACKGROUND_TABLE_TIMES = '#f2f2f2';
export const BACKGROUND_TABLE_TIMES_HOVER = COLOR_1;
export const COLOR_TABLE_TIMES_HOVER = 'white';
export const COLOR_TABLE_TIMES_FULL = '#c7caca';
export const BORDER_COLOR_TABLE_TIMES = '#656565';
export const FONT_SIZE_TABLE_TIMES_ROW = 1;
export const FONT_SIZE_TABLE_TIMES_HEADER = 1;

// CSS - CALENDAR
export const BACKGROUND_CALENDAR = '#f2f2f2';
export const BACKGROUND_CALENDAR_HOVER = '#dedede';
export const BACKGROUND_CALENDAR_SELECTED = COLOR_1;
export const COLOR_CALENDAR_OUTSIDE = '#b5bcbc';
export const COLOR_CALENDAR_FREE = 'black';
export const COLOR_CALENDAR_OCCUPIED = '#e91a1a';
export const COLOR_CALENDAR_NOTAVAILABLE = '#c7caca';
export const COLOR_CALENDAR_BLOCKED = '#c7caca';
export const COLOR_CALENDAR_HOLIDAY = '#44b0fb';
export const FONT_SIZE_CALENDAR = 1;
export const FONT_SIZE_CALENDAR_LEGEND_TEXT = 1;
export const FONT_SIZE_CALENDAR_LEGEND_ICON = 1;

// CSS - STATS_TABLE_INPUT
export const BACKGROUND_STATS_TABLE_ODD_ROW = '#f2f2f2';
export const COLOR_STATS_TABLE_BORDER = '#a6a6a6';
export const BACKGROUND_STATS_TABLE_ROW = 'white';
export const FONT_SIZE_STAST_TABLE_TH = '0.8';
export const FONT_SIZE_STAST_TABLE_TD = '0.9';
export const COLOR_STATS_TABLE_ARROW = '#a6a6a6';
export const COLOR_STATS_TABLE_ARROW_ACTIVE = 'black';
export const WIDTH_STATS_TABLE_COL_FIRST_PCT = '28'; // WIDTH_STATS_TABLE_COL_FIRST_PCT + X * WIDTH_STATS_TABLE_COL_OTHER_PCT = 100%
export const WIDTH_STATS_TABLE_COL_OTHER_PCT = '18';

// CSS - CONTROLLED_INPUT
export const BORDER_COLOR_CONTROLLED_INPUT_NORMAL = '#656565';
export const BORDER_COLOR_CONTROLLED_INPUT_VALID = '#64a105';
export const BORDER_COLOR_CONTROLLED_INPUT_ERROR = '#ce1c1c';
export const COLOR_CONTROLLED_INPUT_NORMAL = '#9b9b9b';

// CSS - INFO_WRAPPER
export const FONT_SIZE_INFO_WRAPPER_TITLE = 1; 
export const FONT_SIZE_INFO_WRAPPER_TEXT = 1;
export const COLOR_ICON_INFO_WRAPPER = COLOR_3;

// CSS - RESERVATION_ERROR
export const BACKGROUND_RESERVATION_ERROR_INFO = 'rgba(235, 111, 131, 0.36)';
export const COLOR_RESERVATION_ERROR_ICON = '#b91111';
export const FONT_SIZE_RESERVATION_ERROR_ICON = 2;

// CSS - RESERVATION_SUCCESS
export const BACKGROUND_RESERVATION_SUCCESS_INFO = 'rgba(148, 204, 95, 0.5)';
export const COLOR_RESERVATION_SUCCESS_ICON = '#237416';
export const FONT_SIZE_RESERVATION_SUCCESS_ICON = 2;

// CSS - EMAIL_CONFIRM
export const BACKGROUND_EMAIL_CONFIRM_INFO_SUCCESS = 'rgba(148, 204, 95, 0.5)';
export const COLOR_EMAIL_CONFIRM_ICON_SUCCESS = '#237416';
export const BACKGROUND_EMAIL_CONFIRM_INFO_ERROR = 'rgba(235, 111, 131, 0.36)';
export const COLOR_EMAIL_CONFIRM_ICON_ERROR = '#b91111';
export const BACKGROUND_EMAIL_CONFIRM_INFO_WARNING = 'rgba(235, 209, 111, 0.36)';
export const COLOR_EMAIL_CONFIRM_ICON_WARNING = '#fa8320';
export const FONT_SIZE_EMAIL_CONFIRM_ICON = 2;

// CSS - DELETE_RESERVATION
export const BACKGROUND_DELETE_RESERVATION_INFO_SUCCESS = 'rgba(148, 204, 95, 0.5)';
export const COLOR_DELETE_RESERVATION_ICON_SUCCESS = '#237416';
export const BACKGROUND_DELETE_RESERVATION_INFO_ERROR = 'rgba(235, 111, 131, 0.36)';
export const COLOR_DELETE_RESERVATION_ICON_ERROR = '#b91111';
export const BACKGROUND_DELETE_RESERVATION_INFO_WARNING = 'rgba(235, 209, 111, 0.36)';
export const COLOR_DELETE_RESERVATION_ICON_WARNING = '#fa8320';
export const FONT_SIZE_DELETE_RESERVATION_ICON = 2;

// CSS - GRAPH
export const COLOR_GRAPH_NO_DATA = COLOR_1;


// CSS - SWITCH
export const SWITCH_BACKGROUND_COLOR = COLOR_3;

// ~ CSS ~ //


// ~ INPUT STATES ~ //

export const CONTROLLED_INPUT_NORMAL = 'normal';
export const CONTROLLED_INPUT_VALID = 'valid';
export const CONTROLLED_INPUT_INVALID = 'invalid';

// ~ REDUCERS ~ //

export const MAIN_GET_COMMON_DATA = 'MAIN_GET_COMMON_DATA';

export const PENDING = 'PENDING';
export const FULFILLED = 'FULFILLED';
export const REJECTED = 'REJECTED';

export const OFFICES_GET_OFFICES = 'OFFICES_GET_OFFICES';

export const SERVICES_SINGLE_OFFICE_INIT = 'SERVICES_SINGLE_OFFICE_INIT';
export const SERVICES_GET_OFFICE_INFO ='SERVICES_GET_OFFICE_INFO';
export const SERVICES_GET_OFFICE_STATS ='SERVICES_GET_OFFICE_STATS';
export const SERVICES_GET_SERVICES ='SERVICES_GET_SERVICES';

export const INTERVALS_GET_DAYS = 'INTERVALS_GET_DAYS';
export const INTERVALS_GET_INTERVALS = 'INTERVALS_GET_INTERVALS';
export const INTERVALS_GET_OFFICE_INFO ='INTERVALS_GET_OFFICE_INFO';
export const INTERVALS_GET_OFFICE_STATS ='INTERVALS_GET_OFFICE_STATS';
export const INTERVALS_SELECT_DAY = 'INTERVALS_SELECT_DAY';
export const INTERVALS_RESET_DATA = 'INTERVALS_RESET_DATA';

export const RESERVATION_POST_RESERVE_INTERVAL = 'RESERVATION_POST_RESERVE_INTERVAL';
export const RESERVATION_PUT_CONFIRM = 'RESERVATION_PUT_CONFIRM';
export const RESERVATION_DELETE_FREE_INTERVAL = 'RESERVATION_DELETE_FREE_INTERVAL';
export const RESERVATION_CLICK_CONFIRM_BTN = 'RESERVATION_CLICK_CONFIRM_BTN';
export const RESERVATION_CHANGE_INPUT = 'RESERVATION_CHANGE_INPUT';
export const RESERVATION_TIME_EXPIRATION = 'RESERVATION_TIME_EXPIRATION';
export const RESERVATION_GET_OFFICE_INFO ='RESERVATION_GET_OFFICE_INFO';

export const CONFIRM_MAIL_CONFIRM = 'CONFIRM_MAIL_CONFIRM';

export const DELETE_RESERVATION_DELETE = 'DELETE_RESERVATION_DELETE';

export const OFFICE_STATS_YEAR = 'OFFICE_STATS_YEAR';
export const OFFICE_STATS_MONTH = 'OFFICE_STATS_MONTH';
export const OFFICE_STATS_RESET = 'OFFICE_STATS_RESET';
export const OFFICE_STATS_SWITCH = 'OFFICE_STATS_SWITCH';
export const OFFICE_STATS_SELECT_DAY = 'OFFICE_STATS_SELECT_DAY';
export const OFFICE_STATS_CHANGE_DATE = 'OFFICE_STATS_CHANGE_DATE';

export const STATS__MODAL_STATS__TOGGLE = 'STATS__MODAL_STATS__TOGGLE';
export const STATS__MODAL_STATS__SELECT_OFFICE = 'STATS__MODAL_STATS__SELECT_OFFICE';
export const STATS__MODAL_STATS__GET_OFFICES ='STATS__MODAL_STATS__GET_OFFICES';
export const STATS__MODAL_STATS__GET_STATS ='STATS__MODAL_STATS__GET_STATS';

// ~ REDUCERS ~ //



// WEBPACK FOOTER //
// ./src/globals.js